export default "__VITE_ASSET__DVnsgxSX__"